import styled from 'styled-components';

export const Container = styled.div`
  display: block;
`;

export const VolumeContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1.5rem;
  margin-bottom: 1rem;
`;

export const RequestErrorText = styled.span`
  margin-bottom: 2rem;
`;
